<template>
  <div
    :id="`focus-${data.slug}-button`"
    :class="activityWrapperClasses"
    @click="toggleActivityFocus"
  >
    <div class="mb-2 activity-unit-tags ">
      <s-tag v-if="isRequestRemedial" variant="danger" type="status" class="s-mr-3">
        {{remedialTagWording}}
      </s-tag>
      <component
        :is="presenceActivityTagConfig.componentName"
        :key="presenceActivityTagConfig.key"
        v-bind="presenceActivityTagConfig.props"
      >
        {{presenceActivityTagConfig.text}}
      </component>
      <component
        v-if="!isRemedialWithPendingSubmission"
        :is="submissionTagConfig.componentName"
        :key="submissionTagConfig.key"
        v-bind="submissionTagConfig.props"
      >
        {{submissionTagConfig.text}}
      </component>
      <s-tag-local
        v-if="data.is_addon_resource"
        bg-color="--color-eucalyptus-100"
        text-color="--color-eucalyptus-700"
      >
        Aktivitas Tambahan
      </s-tag-local>
      <s-tag-local
        v-else-if="isCompulsoryActivity"
        bg-color="--color-deep-lemon-100"
        text-color="--color-deep-lemon-900"
      >
        Aktivitas Wajib
      </s-tag-local>
    </div>
    <div
      class="d-flex align-items-start fw-600 fs-14 activity-unit-content"
      :class="{ 'text-eucalyptus-700': data.is_addon_resource && !data.enrolled, 'text-gargoyle': data.enrolled && !isFromTopicAddon, 'text-placeholder':  isFromTopicAddon }"
    >
      <img
        :src="iconCompletion"
        class="activity-complete-icon mr-2"
        :class="iconCompletionClass"
      />
      <div class="mr-2 activity-unit-number">
        {{number}}.
      </div>
      <div class="activity-unit-detail">
        <p class="mb-1 three-line-ellipsis activity-unit-title" :class="{ 'text-eucalyptus-700': isFromTopicAddon }">
          {{data.title}}
        </p>
        <div class="d-flex mb-2">
          <span class="mr-2 fw-400 fs-12 meta-info text-gargoyle">
            <img :src="data.activity_type_icon" class="img-fluid meta-info-icon" :class="{ 'from-topic-addon-icon': isFromTopicAddon }" loading="lazy" />
            {{data.activity_type_label}}
          </span>
          <span class="fw-400 fs-12 meta-info text-gargoyle" v-if="data.duration">
            <img src="@/assets/icons/activity-v2/icon-jam.svg" class="img-fluid meta-info-icon" :class="{ 'from-topic-addon-icon': isFromTopicAddon }" />
            {{data.duration}} Menit
          </span>
        </div>
        <s-tag
          v-if="data.relation_id && data.is_parent"
          variant="warning"
          type="highlight"
          :title="`Prasyarat Aktivitas ${data.relation_title}`"
        >
          <span class="two-line-ellipsis">Prasyarat Aktivitas {{data.relation_title}}</span>
        </s-tag>
        <div class="mb-3">
          <p
            class="fw-400 fs-14 mb-2 activity-addon-description text-ui-primary"
            v-if="data.is_addon_resource && data.addon_resource_detail.description.length && !data.enrolled"
            :class="{ 'two-line-ellipsis': !isFullDescriptionVisible }"
            v-html="$XSSFilter(data.addon_resource_detail.description)"
          >
          </p>
          <div
            class="mb-3 text-persian-blue-500 cursor-pointer"
            @click.stop="toggleFullDescripton"
            v-if="data.is_addon_resource && data.addon_resource_detail.description.length > 80 && !data.enrolled"
            :id="`toggleFullDescription-${number}`"
          >
            {{toggleDescriptionText}}
            <img
              src="@/assets/icons/activity-v2/chevron-down.svg"
              class="img-fluid toggle-description-icon unrotate-class"
              :class="{ 'rotate-class': isFullDescriptionVisible }"
            />
          </div>
          <span
            class="d-block mb-3 fw-400"
            :class="{
              'text-crimson-500': isThresholdQuota,
              'text-gargoyle': !isThresholdQuota
            }"
            v-if="data.is_addon_resource && !data.is_group_activity && !data.enrolled"
          >
            {{data.addon_resource_detail.current_quota}} Kuota Tersisa
          </span>
          <div class="d-flex justify-content-between" v-if="data.is_addon_resource && !data.enrolled">
            <div>
              <span v-if="data.is_group_activity" class="d-block text-gargoyle fs-12 fw-400">
                Harga Mulai Dari
              </span>
              <span v-else class="d-block text-gargoyle fs-12 fw-400">
                Harga
              </span>
              <span class="primary-font-color">
                +{{formatRupiah(data.addon_resource_detail.price)}}
              </span>
            </div>
            <div>
              <s-button
                pill
                variant="secondary"
                class="btn-enroll-addon"
                :disabled="!data.addon_resource_detail.current_quota"
                @onClick="openBuyAddonModal"
                id="enroll-activity-addon"
              >
                {{joinActivityText}}
              </s-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import deviceDetector from 'mobile-device-detect'
import STagLocal from '@/components/atoms/Tags/STag'
import SButton from '@/components/atoms/buttons/SButton'
import { formatRupiahMixin } from '@/mixins/formatRupiahMixin'
import ProgramActivityAPI from '@/api/program-activity'
import activityV2GeneralMixin from '@/mixins/activityV2/general'
import activityV2SidebarMixin from '@/mixins/activityV2SidebarMixin'
import { swalFire } from '@/functions/swalHelper'
import { ACTIVITY_OPEN } from '@/constants/lockActivity'
import pmoSubmissionStatus from '@/constants/pmoSubmissionStatus'

export default {
  name: 'ActivityRegular',
  mixins: [
    formatRupiahMixin,
    activityV2GeneralMixin,
    activityV2SidebarMixin
  ],
  components: {
    STagLocal,
    SButton
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    number: {
      type: Number,
      default: 0
    },
    isLinier: {
      type: Boolean,
      default: false
    },
    isFromTopicAddon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFullDescriptionVisible: false,
      isActivityComplete: false,
      isPageView: false
    }
  },
  computed: {
    activityDashboard () {
      return this.$store.state.activityV2.activityDashboard
    },
    isActive () {
      return this.$route.params.id === this.data.slug
    },
    activityWrapperClasses () {
      return [
        'pb-3', 'pt-3', 'position-relative', 'activity-unit', 'ff-primary', 'cursor-pointer',
        {
          'current-activity': this.isTour ? this.data.id === 1 : this.isActive && !this.isFromTopicAddon && !this.data.is_addon_resource,
          'd-none': this.data.is_addon_resource && !this.data.enrolled && !this.data.addon_resource_detail.is_available
        }
      ]
    },
    isThresholdQuota () {
      return this.data.addon_resource_detail.current_quota <= 5
    },
    toggleDescriptionText () {
      return this.isFullDescriptionVisible ? 'Tutup Penjelasan' : 'Selengkapnya'
    },
    joinActivityText () {
      return this.data.addon_resource_detail.current_quota ? 'Ikut Aktivitas' : 'Kuota Habis'
    },
    isChatBoxOpen () {
      return this.$store.state.activityV2.isChatBoxOpen
    },
    isCompulsoryActivity () {
      return !this.data.is_addon_resource && this.data.bobot_percentage > 0
    },
    isPresenceActivity () {
      return !this.data.is_addon_resource && !this.data.is_complete && this.data.is_presence_participation
    },
    isAbsentPresenceActivity () {
      return !this.data.is_addon_resource && this.data.is_complete && this.data.is_presence_participation && this.data.presence
    },
    isAbsentRelationActivity () {
      return !this.data.is_addon_resource && this.data.is_complete && this.data.relation_id && !this.data.is_parent && this.data.presence
    },
    isAttending () {
      return !this.data.is_addon_resource && this.data.is_complete && this.data.is_presence_participation && !this.data.presence
    },
    isActivityOpen () {
      return this.activityFocus.lock_result === ACTIVITY_OPEN
    },
    countAbsentPercentage () {
      const { uncompleted_presence_resource, total_presence_participation_resource } = this.activityDashboard

      return 100 * (uncompleted_presence_resource / total_presence_participation_resource)
    },
    isAbsentBelow20Percent () {
      return this.countAbsentPercentage < 20
    },
    isAbsentAbove20Percent () {
      return this.countAbsentPercentage > 20
    },
    isReminderCompletePresenceActivityShown () {
      return !this.isPageView && this.isActivityOpen && !this.data.is_complete && this.uncompletedPresenceResource === 1 && this.data.is_presence_participation
    },
    isResetRejectedActivityByPmo () {
      return this.$store.state.activityV2.isResetRejectedActivityByPmo
    },
    isTaskSubmissionFailed () {
      return this.isPrakerjaPurchaseType && (this.isSelfPacedLearning || this.isWebinarProgram) && this.data.pmo_submission_status === pmoSubmissionStatus.FAILED
    },
    isTaskPending () {
      return this.isPrakerjaPurchaseType && (this.isSelfPacedLearning || this.isWebinarProgram) && (this.data.pmo_submission_status === pmoSubmissionStatus.PENDING_INTERNAL || this.data.pmo_submission_status === pmoSubmissionStatus.PENDING)
    },
    isRequestRemedial () {
      return this.data.is_request_remedial === 1
    },
    isRemedialWithPendingSubmission () {
      return this.isRequestRemedial && this.isTaskPending
    },
    remedialTagWording () {
      return this.isRemedialWithPendingSubmission
        ? 'Tugas Belum Diterima'
        : 'Belum Memenuhi Kriteria'
    },
    iconCompletion () {
      switch (true) {
        case this.isAbsentPresenceActivity || this.isAbsentRelationActivity:
          return 'https://cdn.karier.mu/assets/icon/activity-v2/absent.svg'
        case this.isTaskSubmissionFailed || this.isRequestRemedial:
          return 'https://cdn.karier.mu/assets/icon/common/failed.svg'
        case this.isTaskPending:
          return 'https://cdn.karier.mu/assets/icon/activity-v2/activity-complete-pending.svg'
        default:
          return 'https://cdn.karier.mu/assets/icon/activity-v2/activity-complete.svg'
      }
    },
    iconCompletionClass () {
      return { invisible: !this.isActivityComplete }
    },
    navigateId () {
      return this.$route.query.navigate_id
    },
    presenceActivityTagConfig () {
      switch (true) {
        case !!this.isPresenceActivity:
          return {
            componentName: 's-tag-local',
            key: '0',
            text: 'Sesi Kehadiran',
            props: {
              'bg-color': '--color-deep-lemon-500',
              'text-color': '--color-text-primary',
              class: 's-mr-3'
            }
          }
        case !!this.isAbsentPresenceActivity:
          return {
            componentName: 's-tag',
            key: '1',
            text: 'Tidak Hadir',
            props: {
              variant: 'danger',
              type: 'status',
              class: 's-mr-3'
            }
          }
        case !!this.isAttending:
          return {
            componentName: 's-tag',
            key: '2',
            text: 'Hadir',
            props: {
              variant: 'success',
              type: 'status',
              class: 's-mr-3'
            }
          }
        default:
          return {
            componentName: '',
            key: 0,
            text: '',
            props: {}
          }
      }
    },
    submissionTagConfig () {
      switch (true) {
        case this.isTaskSubmissionFailed:
          return {
            componentName: 's-tag',
            key: '0',
            text: 'Gagal Dikumpulkan',
            props: {
              variant: 'danger',
              type: 'status',
              class: 's-mr-3'
            }
          }
        case this.isTaskPending:
          return {
            componentName: 's-tag',
            key: '1',
            text: 'Sedang Diproses',
            props: {
              variant: 'warning',
              type: 'status',
              class: 's-mr-3'
            }
          }
        default:
          return {
            componentName: '',
            key: 0,
            text: '',
            props: {}
          }
      }
    },
    uncompletedPresenceResource () {
      return this.activityDashboard.uncompleted_presence_resource
    },
    platinumParam () {
      if (this.$route.query.subdomain_slug) {
        return `subdomain_slug=${this.$route.query.subdomain_slug}`
      }
      return ''
    }
  },
  methods: {
    toggleFullDescripton () {
      this.isFullDescriptionVisible = !this.isFullDescriptionVisible
    },
    openBuyAddonModal () {
      this.$store.commit('activityV2/SET_ADDON_BUY_MODAL_VISIBILITY', true)
    },
    async getActivityDetail (id) {
      try {
        const { user_id, program_id } = this.activityValidate
        const result = await ProgramActivityAPI.getActivityDetail({
          Authorization: this.authorization,
          data: {
            user_id,
            program_id,
            activity_id: Number(id) || this.data.id
          }
        })
        if (result.data.status === 200) {
          this.setActivityFocus(result.data.data)
        } // Todo: Handle content error state in main content
      } catch (error) {
        console.error(error)
      }
    },
    setActivityFocus (activity) {
      this.$store.commit('activityV2/SET_ACTIVITY_FOCUS', activity)
      this.$store.commit('activityV2/SET_ACTIVITY_RESOURCE_DETAIL', activity.resource_detail)
      this.$store.commit('activityV2/SET_CURRENT_USER_ACTIVITY_ID', activity.user_activity.id)
      this.$store.commit('activityV2/SET_CURRENT_ACTIVITY_ID', activity.resource_detail.id)
      this.$store.commit('activityV2/SET_CURRENT_ACTIVITY_NUMBER', this.number)
      this.$store.commit('activity/CHANGE_ACTIVITY_FOCUS', activity.resource_detail)

      if (activity.resource_detail.type === 'quiz' || activity.resource_detail.type === 'refleksi') {
        this.$store.commit('quizV2/SET_QUIZ_DETAIL', activity.resource_detail.quiz_detail)
        this.$store.commit('quizV2/SET_IS_REFLECTION', activity.resource_detail.quiz_detail.is_refleksi)
        this.$store.commit('quizV2/SET_QUIZ_LOADING', true)
      }

      if (this.isChatBoxOpen) {
        this.$store.commit('activityV2/SET_CHAT_BOX', false)
      }

      if (this.isReminderCompletePresenceActivityShown) {
        // Trigger popup only when user click / tap activity in sidebar
        this.showReminderCompletePresenceActivity()
      }

      if (this.isPageView) {
        this.isPageView = false
      }
    },
    setActivityFocusRoute () {
      // prevent error duplicate navigation
      this.logActivityEvent('activity_view')
      const path = `/aktivitas/${this.data.slug}${this.platinumParam ? `?${this.platinumParam}` : ''}`
      if (this.$route.path !== path) this.$router.push(path)
    },
    showReminderCompletePresenceActivity () {
      swalFire({
        imageUrl: 'https://cdn.karier.mu/assets/images/illustration/activity-v2/aktivitas-kehadiran-minimal-kehadiran.webp',
        imageWidth: 192,
        title: 'Ikuti Aktivitas Sesi Kehadiran',
        message: 'Untuk mendapatkan sertifikat, Anda harus memiliki persentase kehadiran <strong>minimal 80%.</strong>',
        confirmButtonText: 'Mengerti',
        allowOutsideClick: false
      })
    },
    async toggleActivityFocus () {
      await this.getActivityDetail(this.navigateId) // Todo: handle caching to speedup performance
      this.setActivityFocusRoute()
      deviceDetector.isMobile && this.toggleSidebar()
    }
  },
  watch: {
    'activityResourceDetail.is_complete' (value, prevValue) {
      if (this.isActive) { // Todo: handle missing active activity
        if (value !== prevValue && this.isActivityStarted && this.activityResourceDetail.id === this.data.id) {
          this.isActivityComplete = value
        }
      }
    },
    navigateId (nextValue, prevValue) {
      if (nextValue !== prevValue) {
        if (this.$route.params.id === this.data.slug) {
          this.getActivityDetail(nextValue)
        }
      }
    },
    isResetRejectedActivityByPmo (value) {
      if (value) {
        this.getActivityDetail(this.activityResourceDetail.id)
        this.$store.commit('activityV2/RESET_REJECTED_ACTIVITY_BY_PMO', false)
      }
    }
  },
  mounted () {
    this.isActivityComplete = this.data.is_complete
    if (this.isActive) {
      this.isPageView = true
      this.getActivityDetail(this.navigateId)
    }
  }
}
</script>
<style scoped>
.activity-unit::before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: -16px;
  height: 100%;
  width: calc(100% + 32px);
  transition: background 0.4s ease-in-out;
  z-index: -1;
}

.activity-unit:hover::before {
  background-color: var(--color-neutral-200);
}

.activity-unit-tags {
  padding-left: 43px;
}

.activity-unit-content {
  /* color: var(--color-ui-text-secondary); */
  line-height: 20px;
}

.activity-addon-description {
  line-height: 20px;
  word-break: break-all;
}

.activity-unit-detail {
  flex-grow: 1;
}

.meta-info-icon {
  width: 16px;
  filter: var(--filter-color-ui-text-secondary);
}

.current-activity {
  pointer-events: none;
}

.current-activity::before,
.current-activity::after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: -16px;
  height: 100%;
}

.current-activity::before {
  width: calc(100% + 32px);
  background-color: var(--color-neutral-200);
  z-index: -1;
}

.current-activity::after {
  width: 8px;
  background-color: var(--color-royal-navy-500);
  z-index: 1;
}

.current-activity .meta-info,
.current-activity .activity-unit-title,
.current-activity .activity-unit-number {
  color: var(--color-royal-navy-500);
}

.current-activity .meta-info-icon {
  filter: var(--filter-color-royal-navy-500);
}

.from-topic-addon-icon {
  filter: var(--filter-color-ui-text-placeholder);
}

.tags-atom:first-of-type {
  margin-right: 8px;
}

::v-deep .s-tag-highlight {
  width: auto;
}

.current-activity ::v-deep .s-tag-highlight {
  pointer-events: auto;
}
</style>
